import { OnboardingSetupStep } from '../types'

export const standardOnboardingStepCountMap: Partial<Record<OnboardingSetupStep, number>> = {
  NAME_PHONE: 1,
  INVOICES: 2,
  INTENT: 3,
}

export const extendedOnboardingStepCountMap: Partial<Record<OnboardingSetupStep, number>> = {
  NAME_PHONE: 1,
  INVOICES: 2,
  WORK_STYLE: 3,
  ACCOUNTING_MANAGEMENT: 4,
  INTENT: 5,
}
